export const SET_DATA = (state, { favorites, list }) => {
  [...favorites, ...list].forEach((signal) => {
    if (!state.map.includes(signal.id)) {
      state.data[signal.id] = signal;
      state.map.push(signal.id);
    }
  });
};

export const SORT_SIGNALS = (state) => {
  if (state.activeSort) return;
  if (state.activeFilter) return;
  
  state.map.sort((a, b) => {
    const A = state.data[a];
    const B = state.data[b];

    const prA = Number(A.pinned) * 2 + Number(A.trending);
    const prB = Number(B.pinned) * 2 + Number(B.trending);

    if (prA !== prB) return prB - prA;

    return (
      new Date(B.publication_date || B.created_at) -
      new Date(A.publication_date || A.created_at)
    );
  });
};

export const CLEAR_DATA = (state) => {
  state.data = {};
  state.map = [];
  state.next = null;
};

export const SET_NEW_SIGNAL = (state, signal) => {
  if (!state.map.includes(signal.id)) {
    state.data[signal.id] = signal;
    state.map.unshift(signal.id);
  }
};

export const UPDATE_DATA = (state, data) => {
  data.forEach((item) => {
    if (!(item.id in state.data)) {
      state.data[item.id] = item;
      state.map.unshift(item.id);
    }
  });
};

export const UPDATE_SIGNAL = (state, upd) => {
  const s = state.data[upd.id];
  if (!s) return;

  Object.assign(s, {
    title: upd.title,
    content: upd.content,
    link: upd.link,
    coin: upd.coin,
    images_list: upd.images_list,
  });
};

export const REFRESH_DATA = (state, data) => {
  data.forEach((item) => {
    const s = state.data[item.id];
    if (!s) return;

    Object.assign(s, {
      change_1d_usd: item.change_1d_usd,
      change_all_time_percent: item.change_all_time_percent,
      price_usd: item.price_usd,
      start_market_cap: item.start_market_cap,
      start_price_usd: item.start_price_usd,
      coin: item.coin,
      ath: item.ath,
      change_ath: item.change_ath,
      atl: item.atl,
      change_atl: item.change_atl,
    });
  });
};